export default {
  title: 'Explore by PONANT',
  pickers: {
    ships: 'Schiff auswählen',
    regions: 'Region auswählen',
    search: 'Finden Sie einen Zwischenstopp',
    empty: 'Leider können wir unter unseren Kreuzfahrtstopps keine Übereinstimmung finden.',
    stopover: 'Zwischenstopp',
  },
  cruising: 'Aktuelle Kreuzfahrt',
  modal: {
    webcam: 'Webcam ansehen',
    visit: '360-Grad-Rundgang',
    showCruise: 'Auf der Karte anzeigen',
    more: 'Mehr erfahren',
    cruiseSeparator: 'Nächste Kreuzfahrt',
    realTimeCheck: 'Webcam ansehen',
    video: 'Entdecken Sie das Schiff im Video',
  },
  ship: {
    more: 'Mehr über die {{name}}',
    allCruises: 'Alle Kreuzfahrten an Bord dieses Schiffes ansehen',
    return: 'Zurück zu den Schiffsdetails',
    nextCruise: 'Nächste Kreuzfahrt',
    nextCruiseMulti: 'Die nächsten Kreuzfahrten',
  },
  stopover: {
    nextCruise: 'Nächste Kreuzfahrt mit Stopp in diesem Hafen',
    nextCruiseMulti: 'Die nächsten Kreuzfahrten mit Stopp in diesem Hafen',
    allCruises: 'Alle Kreuzfahrten mit Stopp in diesem Hafen ansehen',
    panoramas: 'Entdecken Sie die Umgebung',
  },
  cruise: {
    quit: 'Ausgewählte Reise verlassen',
    from: '',
    to: 'bis',
    discover:
      'Entdecken Sie die einzelnen Stopps der Reise. Hafen auswählen, anklicken und mehr erfahren.',
    begin: 'Starten',
    close: 'Ausgewählte Reise verlassen',
    noImage: 'Bild nicht verfügbar',
  },
  close: 'Schließen',
  showMore: 'Mehr anzeigen',
  regions: {
    alaska: 'Alaska',
    arctic: 'Arktis',
    northAmerica: 'Nordamerika & Kanada',
    northEurope: 'Nordeuropa',
    mediterranea: 'Mittelmeer',
    asia: 'Asien',
    redSea: 'Rotes Meer',
    caribbean: 'Karibik',
    centralAmerica: 'Mittelamerika',
    southAmerica: 'Südamerika',
    africa: 'Afrika & Indischer Ozean',
    atlantic: 'Atlantikküste',
    oceania: 'Ozeanien & Pazifik',
    antarctic: 'Antarktis',
  },
  branding: {
    body: 'Tauchen Sie virtuell ein in eine ferne Welt! Entdecken Sie unsere Reiseziele virtuell, ganz so, als wären Sie selbst vor Ort.',
    action: 'Start',
  },
}
